import { APPOINTMENT_STATUS, CANCEL_CONFIG, CHECK_IN_CONFIG, CONFIRM_CONFIG, NEW_CONFIG, NO_SHOW_CONFIG, ON_HOLD_CONFIG,  } from 'features/appointment/services/constants';

export const NAME_REDUCER = 'customer';

export const PREFIX_ACTIONS = 'customer_feature_';

export const PATH_LOADING = {
  getData: `loading.${NAME_REDUCER}.getData`,
  getCustomers: `loading.${NAME_REDUCER}.getCustomers`,
  getAppointments: `loading.${NAME_REDUCER}.getAppointments`,
  getTransactions: `loading.${NAME_REDUCER}.getTransactions`,
  getReferrals: `loading.${NAME_REDUCER}.getReferrals`,
  getSummaryReport: `loading.${NAME_REDUCER}.getSummaryReport`,
  getCustomersActive: `loading.${NAME_REDUCER}.getCustomersActive`,
  getCoupons: `loading.${NAME_REDUCER}.getCoupons`,
  getActiveCoupons: `loading.${NAME_REDUCER}.getActiveCoupons`,
};

export const ICustomerStatus = {
  NEW: 'NEW',
  VIP: 'VIP',
  DELETE: 'DELETE',
  REGULAR: 'REGULAR',
};

export const optionsSpendingAmount = [
  { value: '', label: 'All' },
  { value: '1', label: '> $1,000.00' },
  { value: '2', label: '$501.00 - $1,000.00' },
  { value: '3', label: '$301.00 - $500.00' },
  { value: '4', label: '$100.00 - $300.00' },
  { value: '5', label: '< $100.00' },
];
export const optionsPoint = [
  { value: '', label: 'All' },
  { value: '1', label: '> 1,000' },
  { value: '2', label: '501- 1,000' },
  { value: '3', label: '301 - 500' },
  { value: '4', label: '100 - 300' },
  { value: '5', label: '< 100' },
];
export const optionsStatus = [
  { value: 'VIP', label: 'Vip' },
  { value: 'NEW', label: 'New' },
  { value: 'REGULAR', label: 'Regular' },
  { value: 'DELETED', label: 'Deleted' },
];

export const appointmentStatusCustomerConfig = {
  [APPOINTMENT_STATUS.NEW]: {
    label: 'NEW',
    fill: NEW_CONFIG.value.fill,
    stroke: NEW_CONFIG.value.stroke,
  },
  [APPOINTMENT_STATUS.ON_HOLD]: {
    label: 'ON HOLD',
    fill: ON_HOLD_CONFIG.value.fill,
    stroke: ON_HOLD_CONFIG.value.stroke,
  },
  [APPOINTMENT_STATUS.CONFIRM]: {
    label: 'CONFIRM',
    fill: CONFIRM_CONFIG.value.fill,
    stroke: CONFIRM_CONFIG.value.stroke,
  },
  [APPOINTMENT_STATUS.CANCEL]: {
    label: 'CANCEL',
    fill: CANCEL_CONFIG.value.fill,
    stroke: CANCEL_CONFIG.value.stroke,
  },
  [APPOINTMENT_STATUS.NO_SHOW]: {
    label: 'NO SHOW',
    fill: NO_SHOW_CONFIG.value.fill,
    stroke: NO_SHOW_CONFIG.value.stroke,
  },
  [APPOINTMENT_STATUS.CHECK_IN]: {
    label: 'CHECK IN',
    fill: CHECK_IN_CONFIG.value.fill,
    stroke: CHECK_IN_CONFIG.value.stroke,
  },
  [APPOINTMENT_STATUS.DELETE]: {
    label: 'DELETED',
    fill: CANCEL_CONFIG.value.fill,
    stroke: CANCEL_CONFIG.value.stroke,
  },
  [APPOINTMENT_STATUS.PAID]: {
    label: 'PAID',
    fill: CHECK_IN_CONFIG.value.fill,
    stroke: CHECK_IN_CONFIG.value.stroke,
  },
};